import { render, staticRenderFns } from "./KarInterno.vue?vue&type=template&id=a28c0cd0&scoped=true"
import script from "./KarInterno.vue?vue&type=script&lang=js"
export * from "./KarInterno.vue?vue&type=script&lang=js"
import style0 from "./KarInterno.vue?vue&type=style&index=0&id=a28c0cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28c0cd0",
  null
  
)

export default component.exports